/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable func-names */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-template */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */

import { ApolloClient, ApolloLink, InMemoryCache, split } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { createClient } from "graphql-ws";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { onError } from "@apollo/client/link/error";
import { RetryLink } from "@apollo/client/link/retry";
import { getMainDefinition } from "@apollo/client/utilities";
import { enqueueSnackbar } from "notistack";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import expressConfig from "./express.json";

let apolloClientInstance = null;
let globalReconnectHandler = null;

const apolloConfig = (onReconnect) => {
  // Update the global sync handler if a new one is provided
  if (onReconnect) {
    globalReconnectHandler = onReconnect;
  }

  // If the client already exists, return the existing instance
  if (apolloClientInstance) {
    return { apolloClient: apolloClientInstance };
  }

  const env = process.env.NODE_ENV || "development";
  const config = expressConfig[env];

  const { agentId: loggedInUserId, mainSuperAdminId } = useActiveUserDetail();

  // -------------------
  // Retry Link for HTTP requests
  // -------------------
  const retryLink = new RetryLink({
    delay: { initial: 300, max: Infinity, jitter: true },
    attempts: {
      max: 5,
      retryIf: (error) => {
        console.log("HTTP Error Details:", error);
        if (error?.result?.errors?.AuthenticationError) {
          window.location.href = "/login";
        }
        return (
          error === "Failed to fetch" || error?.message === "Failed to fetch"
        );
      },
    },
  });

  const httpLink = createUploadLink({
    uri: `${config.graphql_domain}:${config.port}/${config.graphql_endpoint}`,
    credentials: "include",
  });

  // -------------------
  // WebSocket Client with exponential backoff & internet-aware retries
  // -------------------
  const createWsClient = () => {
    return createClient({
      url: `${config.graphql_subscription_domain}:${config.port}/${config.graphql_subscription_endpoint}`,
      lazy: false,
      connectionParams: { userId: loggedInUserId, mainSuperAdminId },
      keepAlive: 30000,
      connectionAckWaitTimeout: 30000,
      // 🔄 Intelligent Retry Strategy
      shouldRetry: () => true,
      retryAttempts: Infinity,
      retryStrategy: async (attempt) => {
        // 🛑 If we are offline, wait silently until the internet returns
        while (!navigator.onLine) {
          // eslint-disable-next-line no-await-in-loop
          await new Promise((resolve) => {
            setTimeout(() => resolve(true), 1000);
          });
        }

        // 🔄 Exponential backoff: 1s, 2s, 4s, 8s... up to 15s (shorter max for better UX)
        const delay = Math.min(2 ** attempt * 1000, 15000);
        console.log(`WS connection lost. Retrying in ${delay / 1000}s...`);
        await new Promise((resolve) => {
          setTimeout(() => resolve(true), delay);
        });
      },
      on: {
        connecting: () => {
          if (navigator.onLine) {
            console.log("WS connecting...", new Date().toString());
          }
        },
        connected: () => {
          console.log(
            "WS connected (Protocol established)",
            new Date().toString(),
          );
          // 🚀 Trigger global refetch with a small delay to ensure subscriptions are ready
          if (globalReconnectHandler) {
            setTimeout(() => {
              console.log("Starting post-reconnect sync...");
              globalReconnectHandler();
            }, 500);
          }
        },
        closed: (event) => {
          console.log(
            "WS disconnected",
            event.code,
            event.reason || "(no reason)",
            new Date().toString(),
          );
        },
        error: (error) => {
          if (navigator.onLine) {
            console.error("WS error", error, new Date().toString());
          }
        },
      },
    });
  };

  const wsClient = createWsClient();
  const wsLink = new GraphQLWsLink(wsClient);

  // -------------------
  // Global Error & Logout Link with Snackbar Throttling
  // -------------------
  let lastNetworkErrorTime = 0;
  const NETWORK_ERROR_COOLDOWN = 5000; // 5 seconds

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      if (Array.isArray(graphQLErrors)) {
        graphQLErrors.forEach(({ message, extensions }) => {
          // 🛡️ Suppress global snackbar for field-level validation errors (JSON strings)
          try {
            const parsed = JSON.parse(message);
            if (
              parsed &&
              (parsed.email ||
                parsed.password ||
                parsed.oldPassword ||
                parsed.newPassword ||
                parsed.code)
            ) {
              return; // Field-level error handled by component, skip global snackbar
            }
          } catch (e) {
            // Not JSON, continue to show snackbar
          }

          const isRateLimit = message?.toLowerCase().includes("too many");
          const isWhatsAppError =
            message?.toLowerCase().includes("whatsapp") ||
            message?.includes("WhatsApp Error");

          if (
            !isRateLimit &&
            !isWhatsAppError &&
            (extensions?.code === "UNAUTHENTICATED" ||
              message?.toLowerCase().includes("auth"))
          ) {
            enqueueSnackbar("Session expired. Please login again.", {
              variant: "error",
            });
            window.location.href = "/login";
            return;
          }

          // 🛡️ If it's a rate limit error, let the component handle it locally (skip global snackbar)
          if (isRateLimit) return;

          enqueueSnackbar(message || "An unexpected error occurred", {
            variant: "error",
            preventDuplicate: true, // internal notistack check
          });
        });
      } else if (typeof graphQLErrors === "object") {
        const message =
          graphQLErrors.message ||
          graphQLErrors.AuthenticationError ||
          "An unexpected error occurred";

        if (graphQLErrors.AuthenticationError) {
          enqueueSnackbar(message, {
            variant: "error",
            preventDuplicate: true,
          });
          window.location.href = "/login";
        } else {
          enqueueSnackbar(message, {
            variant: "error",
            preventDuplicate: true,
          });
        }
      }
    }

    if (networkError) {
      // 🛡️ Suppress "Network error" snackbar if it's actually a rate-limit from the server
      const isRateLimit = networkError?.result?.errors?.some((e) =>
        e.message?.toLowerCase().includes("too many authentication attempts"),
      );
      if (isRateLimit) return;

      const now = Date.now();
      // 🛡️ Deduplicate Network Error snackbars during outages
      if (now - lastNetworkErrorTime > NETWORK_ERROR_COOLDOWN) {
        console.warn(`[Network error]: ${networkError}`);
        enqueueSnackbar(
          "Network error: Please check your internet connection.",
          {
            variant: "error",
            persist: false,
          },
        );
        lastNetworkErrorTime = now;
      }
    }
  });

  // -------------------
  // Split HTTP vs WS
  // -------------------
  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    wsLink,
    httpLink,
  );

  // -------------------
  // Apollo Client
  // -------------------
  apolloClientInstance = new ApolloClient({
    link: ApolloLink.from([retryLink, errorLink, splitLink]),
    cache: new InMemoryCache(),
  });

  // Prevent freezing objects (your previous hack)
  window.Object.freeze = (obj) => obj;

  return { apolloClient: apolloClientInstance };
};

export default apolloConfig;
